/**
 * Reads the year and month of an API month ("2026-09-01", "2026-09-01T00:00:00") as a local date.
 * `new Date("2026-09-01")` is UTC midnight, which shows the previous month west of UTC.
 */
export const parseMonth = (value) => {
    const match = /^(\d{4})-(\d{2})/.exec(value !== null && value !== void 0 ? value : "");
    const month = match ? Number(match[2]) : 0;
    return match && month >= 1 && month <= 12
        ? new Date(Number(match[1]), month - 1, 1)
        : null;
};
